import { expVal } from '@confluence/feature-experiments';

export function isReactCompilerActiveV1() {
	return true;
}

export function isReactCompilerActiveV2(): boolean {
	if (expVal('confluence_enable_react-compiler-runtime-2', 'isEnabled', false)) {
		return true;
	}
	return false;
}
